export const environment = {
    production: true,
    tag: "PROD",
    environmentBanner: "Production Environment",

    authServerBasePath: "https://portalserver.acimobills.com/auth/api",
    portalServerBasePath: "https://portalserver.acimobills.com/portal/api",    

    portalBasicAuth: "Basic dXNyX2Rpc2J1cnNlbWVudHM6cWRXMTRhTG9pZU9zNW00Qw==",

    disbursementsBasePath: '/disbursements/api',
    walletronBasePath: '/walletron/api',
    walletronRegions: [
        {region: "client2prod", baseUrl: "https://clients2.walletron.com"},
        {region: "mbprod", baseUrl: "https://mobills.walletron.com"},
        {region: "mobills2prod", baseUrl: "https://mobills2.walletron.com"},
        {region: "prod", baseUrl: "https://clients.walletron.com"},
        {region: "wuprod", baseUrl: "https://wuprod.walletron.com"}
    ],
    
    passwordResetUrl: 'https://walletron-agent.acimobills.com/auth/psw-reset'

};